/*! instant.page v5.2.0 - (C) 2019-2023 Alexandre Dieulot - https://instant.page/license */
let _chromiumMajorVersionInUserAgent=null,_allowQueryString,_allowExternalLinks,_useWhitelist,_delayOnHover=65,_lastTouchTimestamp,_mouseoverTimer,_preloadedList=new Set()
const DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION=1111
init()
function init(){const isSupported=document.createElement('link').relList.supports('prefetch')
if(!isSupported){return}
const handleVaryAcceptHeader='instantVaryAccept' in document.body.dataset||'Shopify' in window
const chromiumUserAgentIndex=navigator.userAgent.indexOf('Chrome/')
if(chromiumUserAgentIndex>-1){_chromiumMajorVersionInUserAgent=parseInt(navigator.userAgent.substring(chromiumUserAgentIndex+'Chrome/'.length))}
if(handleVaryAcceptHeader&&_chromiumMajorVersionInUserAgent&&_chromiumMajorVersionInUserAgent<110){return}
const mousedownShortcut='instantMousedownShortcut' in document.body.dataset
_allowQueryString='instantAllowQueryString' in document.body.dataset
_allowExternalLinks='instantAllowExternalLinks' in document.body.dataset
_useWhitelist='instantWhitelist' in document.body.dataset
const eventListenersOptions={capture:!0,passive:!0,}
let useMousedown=!1
let useMousedownOnly=!1
let useViewport=!1
if('instantIntensity' in document.body.dataset){const intensity=document.body.dataset.instantIntensity
if(intensity.startsWith('mousedown')){useMousedown=!0
if(intensity=='mousedown-only'){useMousedownOnly=!0}}else if(intensity.startsWith('viewport')){const isNavigatorConnectionSaveDataEnabled=navigator.connection&&navigator.connection.saveData
const isNavigatorConnectionLike2g=navigator.connection&&navigator.connection.effectiveType&&navigator.connection.effectiveType.includes('2g')
if(!isNavigatorConnectionSaveDataEnabled&&!isNavigatorConnectionLike2g){if(intensity=="viewport"){if(document.documentElement.clientWidth*document.documentElement.clientHeight<450000){useViewport=!0}}else if(intensity=="viewport-all"){useViewport=!0}}}else{const milliseconds=parseInt(intensity)
if(!isNaN(milliseconds)){_delayOnHover=milliseconds}}}
if(!useMousedownOnly){document.addEventListener('touchstart',touchstartListener,eventListenersOptions)}
if(!useMousedown){document.addEventListener('mouseover',mouseoverListener,eventListenersOptions)}else if(!mousedownShortcut){document.addEventListener('mousedown',mousedownListener,eventListenersOptions)}
if(mousedownShortcut){document.addEventListener('mousedown',mousedownShortcutListener,eventListenersOptions)}
if(useViewport){let requestIdleCallbackOrFallback=window.requestIdleCallback
if(!requestIdleCallbackOrFallback){requestIdleCallbackOrFallback=(callback)=>{callback()}}
requestIdleCallbackOrFallback(function observeIntersection(){const intersectionObserver=new IntersectionObserver((entries)=>{entries.forEach((entry)=>{if(entry.isIntersecting){const anchorElement=entry.target
intersectionObserver.unobserve(anchorElement)
preload(anchorElement.href)}})})
document.querySelectorAll('a').forEach((anchorElement)=>{if(isPreloadable(anchorElement)){intersectionObserver.observe(anchorElement)}})},{timeout:1500,})}}
function touchstartListener(event){_lastTouchTimestamp=performance.now()
const anchorElement=event.target.closest('a')
if(!isPreloadable(anchorElement)){return}
preload(anchorElement.href,'high')}
function mouseoverListener(event){if(performance.now()-_lastTouchTimestamp<DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION){return}
if(!('closest' in event.target)){return}
const anchorElement=event.target.closest('a')
if(!isPreloadable(anchorElement)){return}
anchorElement.addEventListener('mouseout',mouseoutListener,{passive:!0})
_mouseoverTimer=setTimeout(()=>{preload(anchorElement.href,'high')
_mouseoverTimer=undefined},_delayOnHover)}
function mousedownListener(event){const anchorElement=event.target.closest('a')
if(!isPreloadable(anchorElement)){return}
preload(anchorElement.href,'high')}
function mouseoutListener(event){if(event.relatedTarget&&event.target.closest('a')==event.relatedTarget.closest('a')){return}
if(_mouseoverTimer){clearTimeout(_mouseoverTimer)
_mouseoverTimer=undefined}}
function mousedownShortcutListener(event){if(performance.now()-_lastTouchTimestamp<DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION){return}
const anchorElement=event.target.closest('a')
if(event.which>1||event.metaKey||event.ctrlKey){return}
if(!anchorElement){return}
anchorElement.addEventListener('click',function(event){if(event.detail==1337){return}
event.preventDefault()},{capture:!0,passive:!1,once:!0})
const customEvent=new MouseEvent('click',{view:window,bubbles:!0,cancelable:!1,detail:1337})
anchorElement.dispatchEvent(customEvent)}
function isPreloadable(anchorElement){if(!anchorElement||!anchorElement.href){return}
if(_useWhitelist&&!('instant' in anchorElement.dataset)){return}
if(anchorElement.origin!=location.origin){let allowed=_allowExternalLinks||'instant' in anchorElement.dataset
if(!allowed||!_chromiumMajorVersionInUserAgent){return}}
if(!['http:','https:'].includes(anchorElement.protocol)){return}
if(anchorElement.protocol=='http:'&&location.protocol=='https:'){return}
if(!_allowQueryString&&anchorElement.search&&!('instant' in anchorElement.dataset)){return}
if(anchorElement.hash&&anchorElement.pathname+anchorElement.search==location.pathname+location.search){return}
if('noInstant' in anchorElement.dataset){return}
return!0}
function preload(url,fetchPriority='auto'){if(_preloadedList.has(url)){return}
const linkElement=document.createElement('link')
linkElement.rel='prefetch'
linkElement.href=url
linkElement.fetchPriority=fetchPriority
linkElement.as='document'
document.head.appendChild(linkElement)
_preloadedList.add(url)}